import Axios from 'axios';

const BASE_URL = '/api/students';


export default {

    getAll() {

        return Axios.get(BASE_URL);
    },

    add(data) {
        return Axios.post(BASE_URL, data);
    },

    update(data) {
        return Axios.put(BASE_URL  +'/'+ data.id, data);
    },

    delete(id) {
        return Axios.delete(BASE_URL  +'/'+ id);
    },

    runpromotion(data){
      return Axios.post(BASE_URL+'/promote',data)
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/services/students.js